import * as React from 'react';
export const IcSavings = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.92 5h8.16l.8-1.53A1 1 0 0016 2h-2a1 1 0 00-.68.27L12.5 3l-.82-.76A1 1 0 0011 2H8a1 1 0 00-.88 1.47L7.92 5zm8.26 2H7.82A9.9 9.9 0 004 15c0 .07.09 7 8 7s8-6.93 8-7a9.9 9.9 0 00-3.82-8zm-1.68 6a3 3 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 18a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 14h1a1 1 0 100-2h-2a1 1 0 110-2h5a1 1 0 110 2h-.18c.117.32.177.659.18 1z'
      fill='currentColor'
    />
  </svg>
);
